module.exports = __webpack_public_path__ + "static/media/01.18471b96.mp3";